import { render, staticRenderFns } from "./UpdateAmountDialog.vue?vue&type=template&id=2bb94238"
import script from "./UpdateAmountDialog.vue?vue&type=script&lang=js"
export * from "./UpdateAmountDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports